<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">快捷导航</span>
    </div>
    <el-row :gutter="20">
      <el-col :span="12" class="firstCls">
        <el-row :gutter="5">
          <el-col :span="12">
            <span>商家数统计：</span>
          </el-col>
          <el-col :span="12">
            <span>{{quicklyData.allBusinessNums}}</span>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12">
            <span>增值服务余额：</span>
          </el-col>
          <el-col :span="12">
            <span>{{quicklyData.attachServiceBalancsMoney}}</span>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12">
            <span style="color: blue;">系统总账余额：</span>
          </el-col>
          <el-col :span="12">
            <span style="color: red;">{{quicklyData.systemAccountBalanceMoney}}</span>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12">
            <span>未结算本金：</span>
          </el-col>
          <el-col :span="12">
            <span>{{quicklyData.unBalanceMoney}}</span>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12">
            <span>未结算佣金：</span>
          </el-col>
          <el-col :span="12">
            <span>{{quicklyData.unCommissionMoney}}</span>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12">
            <span>时间：</span>
          </el-col>
          <el-col :span="12">
            <span>{{quicklyData.dateTime}}</span>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12" class="firstCls">
        <el-row :gutter="5">
          <el-col :span="12">
            <span>会员数统计：</span>
          </el-col>
          <el-col :span="12">
            <span>{{quicklyData.allCustomerNums}}</span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-card>
  <el-divider></el-divider>
  <el-card>
    <el-row :gutter="10" class="secondCls">
      <el-col :span="8">
        <el-badge :value="badgeNumbers.bInvestReviewNum" class="item">
        <el-button plain @click="businessInvistReview">商家充值待审核</el-button>
        </el-badge>
      </el-col>
      <el-col :span="8">
        <el-badge :value="badgeNumbers.bGetMoneyReviewNum" class="item">
          <el-button plain @click="businessCashOutReview">商家提现待审核</el-button>
        </el-badge>
      </el-col>
      <el-col :span="6">
        <el-badge :value="badgeNumbers.taskReviewNum" class="item">
          <el-button plain @click="taskReview">任务审核</el-button>
        </el-badge>
    </el-col>
    </el-row>
    <el-row :gutter="10" class="secondCls">
      <el-col :span="8">
        <el-badge :value="badgeNumbers.complainReviewNum" class="item">
          <el-button plain @click="appealWaitReview">申诉待审核</el-button>
        </el-badge>
      </el-col>
      <el-col :span="8">
        <el-badge :value="badgeNumbers.shopsReviewNum" class="item">
          <el-button plain @click="shopReview">店铺待审核</el-button>
        </el-badge>
      </el-col>
      <el-col :span="6">
        <el-badge :value="badgeNumbers.bCustomeReviewNum" class="item">
          <el-button plain @click="salemanCashOutReview">业务员提现待审核</el-button>
        </el-badge>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="secondCls">
      <el-col :span="8">
        <el-badge :value="badgeNumbers.stationLetterNum" class="item">
          <el-button @click="imessageOnclick" plain>站内信</el-button>
        </el-badge>
      </el-col>
      <el-col :span="8">
        <el-badge :value="badgeNumbers.rejectOrderNum" class="item">
          <el-button plain @click="rejeckOrder">驳回中订单</el-button>
        </el-badge>
      </el-col>
      <el-col :span="6">
        <el-badge :value="badgeNumbers.customIdCardReivewNum" class="item">
          <el-button plain @click="customerIdcardVerify">试客身份证待审核</el-button>
        </el-badge>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="secondCls">
      <el-col :span="8">
        <el-badge :value="badgeNumbers.waitBusinessReturnMoneyNum" class="item">
          <el-button plain @click="waitReturnMoneyBusiness">刷新订单</el-button>
        </el-badge>
      </el-col>
      <el-col :span="8">
        <el-badge :value="badgeNumbers.customAccountReviewNum" class="item">
          <el-button plain @click="customerWaitReview">试客账号待审核</el-button>
        </el-badge>
      </el-col>
      <el-col :span="6">
        <el-badge :value="badgeNumbers.customCashOutReviewNum" class="item">
          <el-button plain @click="cusotmerCashOutReview">试客提现待审核</el-button>
        </el-badge>
      </el-col>
    </el-row>
  </el-card>
</div>
</template>

<script>
import {
  queryAdminQuicklyData, queryAppealUnreviewNumbersWithStatus,
  queryBusinessWaitReturnMoneyNumbers,
  queryCustomerAccountNumbers,
  queryIdcardNumbersWithStatus, queryMsgNumbersWithStatus,
  queryOrderNumbersWithStatus,
  queryShopsNumbersWithStatus,
  queryTashNumbersWithStatus
} from "../../api/b2cbusiness/b2c_allquicklydata";
import {queryNumbersWithStatus} from "../../api/b2cbusiness/b2c_investmoney";
import {queryCashOutNumbersWithStatus, reflushOrder} from "../../api/b2cbusiness/b2c_admin";
import B2cWebSocket from "../../lib/websocket";
import * as Util from "../../lib/utils";
import {getJwtToken} from "../../lib/utils";

export default {
name: "AdminFirstPage",
  data(){
  return {
    quicklyData:{
    },
    socketHander: null,
    badgeNumbers:{
      bInvestReviewNum: "0",
      bGetMoneyReviewNum: "0",
      taskReviewNum: "0",
      complainReviewNum: "0",
      shopsReviewNum: "0",
      bCustomeReviewNum: "0",
      stationLetterNum: "0",
      rejectOrderNum: "",
      customIdCardReivewNum: "0",
      waitBusinessReturnMoneyNum: "",
      customAccountReviewNum: "0",
      customCashOutReviewNum: "0"
    }
  }
  },
  mounted() {
      // WebSocket 仅做通知辅助,单独 try/catch,避免其初始化异常(如 token 缺失、连接被拦)阻塞下方数据接口
      try {
        if (this.socketHander == null){
          this.socketHander = new B2cWebSocket({url:"wss://api.weiquanai.com/imessage/"+Util.getTokenUser()+"/sysnotice"});
        }
        this.socketHander.onmessage((res) =>{
          if (res != "b2c_heart" && res != "上线成功！") {
            let msgObject = JSON.parse(res);
            this.$notify.error({
              duration: 2500,
              title: msgObject.title,
              message: msgObject.message
            });
          }
        });
      } catch (e) {
        console.error('AdminFirstPage websocket init error:', e);
      }
      queryAdminQuicklyData().then(res=>{
      if (res.success){
        this.quicklyData = res.data;
      }
    });

    queryNumbersWithStatus({statusStr:"未审核"}).then(res=>{
      if (res.success){
        this.badgeNumbers.bInvestReviewNum = res.data;
      }
    });

    queryCashOutNumbersWithStatus({roleId:"1409884924325670914", statusStr:"未审核"}).then(res=>{
      if (res.success){
        this.badgeNumbers.bGetMoneyReviewNum = res.data;
      }
    });

    queryCashOutNumbersWithStatus({roleId:"1435410074957545474", statusStr:"未审核"}).then(res=>{
      if (res.success){
        this.badgeNumbers.bCustomeReviewNum = res.data;
      }
    });

    queryCashOutNumbersWithStatus({roleId:"1435409842807013377", statusStr:"未审核"}).then(res=>{
      if (res.success){
        this.badgeNumbers.customCashOutReviewNum = res.data;
      }
    });

    queryTashNumbersWithStatus({status:202112260001}).then(res=>{
          if (res.success){
            this.badgeNumbers.taskReviewNum = res.data;
          }
    });

    queryAppealUnreviewNumbersWithStatus({appealStatus: 202111300001}).then(res=>{
      if (res.success){
        this.badgeNumbers.complainReviewNum = res.data;
      }
    });

    queryShopsNumbersWithStatus({reviewStatus:0}).then(res=>{
      if (res.success){
        this.badgeNumbers.shopsReviewNum = res.data;
      }
    });

    queryMsgNumbersWithStatus({msgStatus:false}).then(res=>{
      if (res.success){
        this.badgeNumbers.stationLetterNum = res.data;
      }
    });

    queryOrderNumbersWithStatus({status:202112300001}).then(res=>{
      if (res.success){
        this.badgeNumbers.rejectOrderNum = res.data;
      }
    });

    queryIdcardNumbersWithStatus({status:202111300001}).then(res=>{
      if (res.success){
        this.badgeNumbers.customIdCardReivewNum = res.data;
      }
    });

    queryBusinessWaitReturnMoneyNumbers().then(res=>{
      if (res.success){
        this.badgeNumbers.waitBusinessReturnMoneyNum = res.data;
      }
    });

    queryCustomerAccountNumbers({status:"未审核"}).then(res=>{
      if (res.success){
        this.badgeNumbers.customAccountReviewNum = res.data;
      }
    });
  },
  methods:{
    businessInvistReview(){
      this.$router.push({path:'/home/accountdetlist', query:{userType:"商家", status:"未审核"}})
    },
    businessCashOutReview(){
      this.$router.push({path:'/home/accountoutchlist', query:{userType:"商家", status:"未审核"}})
    },
    salemanCashOutReview(){
      this.$router.push({path:'/home/accountoutchlist', query:{userType:"业务员", status:"未审核"}})
    },
    taskReview(){
      this.$router.push({path:'/home/taskmlist', query:{tabsActive:202112260001}})
    },
    appealWaitReview(){
      this.$router.push({path:'/home/appealmlist', query:{appealStatus:202111300001}})
    },
    shopReview(){
      this.$router.push({path:'/home/shoplist', query:{reviewstatus:"未审核"}})
    },
    imessageOnclick(){
      this.$router.push({path:'/home/imessagelist', query:{msgStatus:0}})
    },
    rejeckOrder(){
      this.$router.push({path:'/home/ordermlist', query:{tabsActive:"202112300001"}})
    },
    customerIdcardVerify(){
      this.$router.push({path:'/home/idcardlist', query:{status:"未审核"}})
    },
    waitReturnMoneyBusiness(){
      //this.$router.push({path:'/home/waitreturnmoney', query:{moneyReturnStatus:false}})
      reflushOrder().then(res=>{
        if (res.success){
          this.$message.success("刷新订单成功");
        }else{
          this.$message.error("刷新订单失败");
        }
      })
    },
    customerWaitReview(){
      this.$router.push({path:'/home/accountmlist', query:{status:"未审核"}})
    },
    cusotmerCashOutReview(){
      this.$router.push({path:'/home/accountoutchlist', query:{userType:"试客", status:"未审核"}})
    },
  },
}
</script>

<style lang="scss" scoped>
.firstCls{
  .el-row {
    margin: 15px;
    .el-col{
      text-align: left;
      span{
        color: #409EFF;
      }
    }
    .el-col:first-child{
      text-align: right;
      span{
        color: #303133;
      }
    }
  }
}

.secondCls{
    .el-col{
       margin: 10px;
    }
}
</style>
